import * as React from 'react';

import {
  Lang,
  Colors,

  Text,
} from '@bluecurrent/web-component-lib';

export default function SuccessMessage(props) {
  const { _ } = Lang.useTranslation();

  return (
    <div
      style={{
        height: '100%',
      }}
    >
      <div
        style={{
          marginBottom: 15,
        }}
      >
        <Text>
          {`${_('sent', { ns: 'ui' })}!`}
        </Text>
        {
          props.content?.text && (
            <div
              style={{
                marginTop: 15,
              }}
            >
              <Text>
                {props.content.text}
              </Text>
            </div>
          )
        }
      </div>
      <button
        type="button"
        onClick={props.onClose}
        className="Hover"
        style={{
          fontSize: '0.9em',
          color: Colors.DARK_WHITE,
          padding: 0,
          backgroundColor: 'transparent',
          border: 'none',
          textDecorationLine: 'underline',
          marginTop: 15,
        }}
      >
        {_('returnToForm', { ns: 'ui' })}
      </button>
    </div>
  );
}
